export default __webpack_public_path__ + "static/media/ic_vietnam.9261f5b4.svg";